module.exports = __webpack_public_path__ + "static/img/product-swipe30.562c2e16.png";